import React, {useState,useRef,useLayoutEffect,useCallback,Fragment,useEffect,useContext} from "react";
import {Table,TableBody,TableCell,TableRow,Checkbox,IconButton,Grid,TextField,Divider, Select, FormControl, MenuItem} from "@mui/material";
import {FooterText,ScrollableFooter,ScrollableTableContainer,TableCircularProgress} from "../styled/ScrollableTable.styled";
import { BiCaretUp, BiX, BiCaretDown } from "react-icons/bi";
import { GrFormClose} from "react-icons/gr";
import { makeStyles } from "@material-ui/core/styles";
import TableHead from "@material-ui/core/TableHead";
import { getAdvancedCapacityData } from "../../services/api/capacityService";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import {StyledTableWrapper} from "../styled/StyledTable.styled";
import { monthOrder } from "../../constants/Data";
import { WebMapContext } from "../../pages/sections/web-map/WebMapGoogleMap";
  const useStyles = makeStyles((theme) => ({
    table: {
     width: "100%",
    },
    smallTextField: {
      minWidth: "83px",
      width: "90px",
      "& input": {
        paddingTop: "2.5px",
        paddingBottom: "2.5px",
        textAlign: "center",
        font: "normal normal normal 10px/15px Open Sans",
        height: "16px"
      },
    },
    smallTextFieldInput: {
      padding: "2.5px 14px",
    },
    gridPadding: {
       width: "75px",
    },
    smallTableRow: {
     height: "10px",
    },
    tableRow: {
     height: "10px",
    },
    tableCell: {
      fontSize: "12px",
      padding: "0px",
    },
    filterTableCell: {
      fontSize: "12px",
      padding: "0px",
    },
    textField: {
      width: "100%",
    },
    smallIconButton: {
      padding: "6px",
    },
    stickyHeader: {
      position: 'sticky',
      top: 0,
      backgroundColor: 'white',
      zIndex:1,
    },
    stickyCell: {
     borderBottom: 'none',
     textAlign: "center"
    },
    stickyBorder:{
      borderBottom: '1px solid #E0E0E0',
      // marginTop: '9px'
    },
    expandIcon:{
      padding: "2px"
    },
    checkIcon:{
      paddingLeft: "9px",
      paddingRight: "9px",
      paddingTop: "2px",
      paddingBottom: "2px"
    },
    tableRightNoBorder: {borderRight : "0px"},
    tableRightBorder : { borderRight: '1px solid #E0E0E0'},
    cellBold : { fontWeight: 'bold'},
    searchOpDropDown: { height: '20px' },
    selectInput: {
      padding: 0,
      minHeight: '1.4375em',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      width: "55px",
      textAlign: "center"
    },
    selectClose: {
      cursor: "pointer",
      position: "absolute",
      right: "7px",
      top: "calc(50% - 0.5em)",
      color: "rgba(0,0,0,0.54)"
    },
    hiddenSortButton: {
      backgroundColor: 'white',
      cursor: 'default',
      color: 'white',
      '&:hover': {
        backgroundColor: 'white',
      },
    },
  }));

  export default function CapacityAdvanceFilter({
    headCells,
    selectedFilters,
    selectedMonth = null,
    selectedOperator = null,
    selectedYear = null,
    dataRows = [],
    page = 1,
    getSelectedData = () => {},
    loadData = () => {},
    dynamicFilters = { flag: [], action: [], months: [] }
  }) {
    const {
      selectedCapacityAdvanceData
    } = useContext(WebMapContext);
    const tableEl = useRef();
    const [rows, setRows] = useState(dataRows);
    const [pageNum, setPageNum] = useState(page);
    const [loading, setLoading] = useState(false);
    const [hasMore] = useState(true);
    const [isFullDataLoad, setIsFullDataLoad] = useState(false);
    const [expandedList, setExpandedList] = React.useState([]);
    const [MasterChecked, setMasterChecked] = React.useState(false);
    const [SelectedList, setSelectedList] = React.useState([]);
    const [showSelectedRows, setShowSelectedRows] = React.useState(false);
    const [checkedItems, setCheckedItems] = useState(false);
    const [advanceSearchFilterValues, setAdvanceSearchFilterValues] = useState([]);
    const [sortingOrder, setSortingOrder] = useState("asc");
    const [isClickedSort, setIsClickedSort] = useState(false);
    const [isClickedSortCol, setIsClickedSortCol] = useState({enodbID:false, secID: false,lat: false, lon: false, enod_rsrp: false, enod_rsrq: false, enod_sinr: false, flag: false, action: false })
    const [storedSorting, setStoredSorting] = useState([]);
    const [sortByVal, setSortByVal] = useState('')
    const [sectorId, setSectorId] = useState("");
    const [lat, setLat] = useState("");
    const [lon, setLon] = useState("");
    const [enodeBID, setEnodeBID] = useState("");
    const [rsrp, setRsrp] = useState("");
    const [rsrq, setRsrq] = useState("");
    const [sinr, setSinr] = useState("");
    const [flag, setFlag] = useState("");
    const [action, setAction] = useState("");
    const [monthFilters, setMonthFilters] = useState({});
    useEffect(() => {
      const getPrevSelectedItems = localStorage.getItem("selectedCapacityFilters")
        ? localStorage.getItem("selectedCapacityFilters") : [];
      const convertedPrevSelectedValue = getPrevSelectedItems.length !== 0 ? JSON.parse(getPrevSelectedItems) : [];
      if (convertedPrevSelectedValue.length !== 0) {
        setCheckedItems(false);
        setShowSelectedRows(false);
        setSelectedList(convertedPrevSelectedValue);
        getSelectedData(convertedPrevSelectedValue);
        localStorage.setItem("tempSelectedCapacityFilters", convertedPrevSelectedValue.length  ? JSON.stringify(convertedPrevSelectedValue) : "");
      }
    }, []);

    useEffect(() => {
      // init month filters
      const filters = {};
      dynamicFilters.months.forEach(month => {
        filters[month] = "";
      });
      setMonthFilters(filters);
    }, [dynamicFilters.months]);

    const onLoadChangeData = async(advanceValues = [], sortingValues = []) => {
      let queryParam = {};
      const adminLvlEnable = selectedFilters.level && selectedFilters.level !== 'geoHashLevel'  && selectedFilters.levelVal
      queryParam.pageNum = page || 1;
      queryParam.countryCode = selectedFilters.countryCode;
      queryParam.quarter = selectedFilters.quarter;
      queryParam.year = selectedYear;
      queryParam.month = selectedMonth;
      queryParam.operator = selectedOperator;
      queryParam.level = adminLvlEnable ? selectedFilters.level : null;
      queryParam.levelVal = adminLvlEnable ? selectedFilters.levelVal : null;
      queryParam.advanceSearchKeys = advanceValues;
      queryParam.sortParams = sortingValues;
      const response = await getAdvancedCapacityData(queryParam);
      const updatedArr = response.data.map(({ _id, rsrq, rsrp, sinr, enodbid, sectors, action, flag, lon, lat}) => {
        const groupList = sectors.map(({ secID, rsrq, rsrp, sinr, months, flag, action }) => {
          const selectedGroup = SelectedList.length > 0
            ? SelectedList.find(selected =>
                selected.groupList.some(group => group.secID === secID && selected.enodbid === enodbid && group.selected)
              ): false;
          const selected = selectedGroup ? true : false;
          return {secID,rsrq,rsrp,sinr,flag,action,
            months,
            // ...months.reduce(
            //   (acc, month, index) => ({
            //     ...acc,
            //     [`month${index + 1}`]: month,
            //   }),
            //   {}
            // ),
            selected: selected,
          };
        });
        return {groupList,expand: false,_id,rsrq,rsrp,sinr,enodbid,action,flag, lat, lon};
      });
      return updatedArr
    }
    const onCheckMaster = (e) => {
      let temporList = rows;
      temporList.forEach((rowLine) => {rowLine.groupList.forEach((subR) => 
      {subR.selected = e.target.checked;})});
      setRows(temporList);
      const listSelected = rows.filter(({ groupList }) => groupList.some(({ selected }) => selected))
        .map(({ ...item }) => {item.groupList = item.groupList.filter(({ selected }) => selected);
          return item });
      setSelectedList(listSelected);
      setMasterChecked(e.target.checked);
      getSelectedData(listSelected);
      const selectedData = listSelected.map((item) => item.enodbid);
       localStorage.setItem("tempSelectedCapacityFilters",selectedData.length !== 0 ? JSON.stringify(listSelected) : "");
    };
    const onCheckRow = (e, detailRow, mainRow) => {
      let tempList = rows;
      tempList.forEach((row) => {
        if (row.enodbid === mainRow.enodbid) {
          mainRow.groupList.forEach((subRow) => {
            if (subRow.secID === detailRow.secID) {
              subRow.selected = e.target.checked;
            }
          });
        }
      });
      const totalItems = rows.reduce((acc, { groupList }) => acc + groupList.length,0);
      const totalCheckedItems = tempList.flatMap(({ groupList }) => groupList.filter(({ selected }) => selected)).length;
      setRows(tempList);
      const newSelected = rows.filter(({ groupList }) => groupList.some(({ selected }) => selected))
        .map(({ ...item }) => {item.groupList = item.groupList.filter(({ selected }) => selected);
          return item;
        });
      const oldSelected = selectedCapacityAdvanceData.filter(itm => !rows.find(x => x.enodbid === itm.enodbid)).map(x => {
        x.groupList = x.sectors;
        delete x.sectors;
        return x;
      });
      const listSelected = [...newSelected, ...oldSelected];
      setSelectedList(listSelected);
      // setMasterChecked(totalItems === totalCheckedItems);
      getSelectedData(listSelected);
      const selectedData = listSelected.map((item) => item.enodbid);
      localStorage.setItem(
        "tempSelectedCapacityFilters",
        selectedData.length !== 0 ? JSON.stringify(listSelected) : ""
      );
    };
    const displaySelectedRows = async () => {
      const isSelected = showSelectedRows ? false : true;
      setShowSelectedRows(isSelected);
      if (isSelected) {
        setMasterChecked(true);
        const SelectedDataRows = SelectedList.map(obj => ({...obj, expand: false}));
        setExpandedList([])
        setRows(SelectedDataRows);
      } else {
        const resData = await loadData(false, 1, storedSorting, advanceSearchFilterValues);
        let resDataRows = resData?.rows;
        const selectedEnodbId = SelectedList.map(obj => obj.enodbid);
        resDataRows = resDataRows.map(obj => {
          if (selectedEnodbId.includes(obj.enodbid)) {
            const selectedObj = SelectedList.find(selObj => selObj.enodbid === obj.enodbid);
            const updatedGroupList = obj.groupList.map(group => {
              const selectedGroup = selectedObj.groupList.find(selGroup => selGroup.secID === group.secID);
              if (selectedGroup) {
                return selectedGroup;
              } else {
                return { ...group, selected: false };
              }
            });
            return { ...obj, groupList: updatedGroupList, expand: false };
          } else {
            return { ...obj, groupList: obj.groupList.map(group => ({ ...group, selected: false })),expand: false };
          }
        });
        setExpandedList([])
        setSelectedList(SelectedList);
        setPageNum(resData?.page);
        setRows(resDataRows);
        setIsFullDataLoad(false);
        setLoading(false);
        setMasterChecked(false);
        getSelectedData(SelectedList);
        const selectedData = SelectedList.map((item) => item.enodbid);
        localStorage.setItem(
         "tempSelectedCapacityFilters",
         selectedData !== 0 ? JSON.stringify(SelectedList) : ""
       );
      }
    };
    const handleChange = (event, searchKey) => {
      if (searchKey === "enodbID") {
        setEnodeBID(event.target.value);
      } else if (searchKey === "secID") {
        setSectorId(event.target.value);
      } else if (searchKey === "lat") {
        setLat(event.target.value);
      } else if (searchKey === "lon") {
        setLon(event.target.value);
       }else if (searchKey === "enod_rsrp") {
        setRsrp(event.target.value);
      } else if (searchKey === "enod_rsrq") {
        setRsrq(event.target.value);
      } else if (searchKey === "enod_sinr") {
        setSinr(event.target.value);
      }  else if (searchKey === "flag") {
        setFlag(event.target.value);
      }  else if (searchKey === "action") {
        setAction(event.target.value);
      } else if (Object.keys(monthOrder).includes(searchKey)) {
        setMonthFilters({ ...monthFilters, [searchKey]: event.target.value });
      }
    };

    // customSearch - used when SELECT_BOX used (eg: flag, action, month)
    // otherwise; state value is used for query (eg: enodb...)
    const formatSearchFilterData = (customSearch = {}) => {
      let filters = [];
      // enod & sec & lat,lon
      if (enodeBID) filters.push({ key: "enodbID", value: enodeBID });
      if (sectorId) filters.push({ key: "secID", value: sectorId });
      if (lat) filters.push({ key: "lat", value: lat });
      if (lon) filters.push({ key: "lon", value: lon });

      // flag & action
      // when flag has prev. selected value
      if (customSearch.key !== "flag" && flag) filters.push({ key: "flag", value: flag });
      // when action has prev. selected value
      if (customSearch.key !== "action" && action) filters.push({ key: "action", value: action });
      // add new flag or action values
      if (customSearch.key === "flag" || customSearch.key === "action") filters.push({ key: customSearch.key, value: customSearch.value });

      // rsrp,sinr,rsrq
      if (rsrp)
        filters.push(
          { key: "enod_rsrp", value: rsrp },
          { key: "sec_rsrp", value: rsrp }
        );
      if (rsrq)
        filters.push(
          { key: "enod_rsrq", value: rsrq },
          { key: "sec_rsrq", value: rsrq }
        );
      if (sinr)
        filters.push(
          { key: "enod_sinr", value: sinr },
          { key: "sec_sinr", value: sinr }
        );

      // months
      // adding already selected month's filters to query
      for (const key in monthFilters) {
        const value = monthFilters[key];
        if (customSearch.key !== key && value !== "") {
          filters.push({ key, value });
        } else if (customSearch.key === key) { // newly selected value for a month
          filters.push({ key, value: customSearch.value });
        }
      }

      const updateArray = [...filters];
      setAdvanceSearchFilterValues(updateArray);
      return updateArray;
    };
    const handleSearchClear = async (event, searchKey) => {
      setIsFullDataLoad(false)
      setPageNum(1)
      let updateFilterArray = advanceSearchFilterValues.filter((obj) => {
        if (searchKey === "enod_rsrq") { // for both enod_rsrq,sec_rsrq; enod_rsrq used as key
          return obj.key !== searchKey && obj.key !== "sec_rsrq";
        } else if (searchKey === "enod_rsrp") {
          return obj.key !== searchKey && obj.key !== "sec_rsrp";
        } else if (searchKey === "enod_sinr") {
          return obj.key !== searchKey && obj.key !== "sec_sinr";
        } else {
          return obj.key !== searchKey; // remove enod, sec, flag,action,months
        }
      });
      setAdvanceSearchFilterValues(updateFilterArray);
      if (searchKey === "enodbID") {
        setEnodeBID("");
      } else if (searchKey === "secID") {
        setSectorId("");
      } else if (searchKey === "lat") {
        setLat("");
      } else if (searchKey === "lon") {
        setLon("");
      } else if (searchKey === "enod_rsrp") {
        setRsrp("");
      } else if (searchKey === "enod_rsrq") {
        setRsrq("");
      } else if (searchKey === "enod_sinr") {
        setSinr("");
      } else if (searchKey === "flag") {
        setFlag("");
      } else if (searchKey === "action") {
        setAction("");
      } else if (Object.keys(monthOrder).includes(searchKey)) {
        setMonthFilters({ ...monthFilters, [searchKey]: "" }); // remove month filter
      }
      if (advanceSearchFilterValues.length !== 0) {
        const updatedData = await onLoadChangeData(updateFilterArray)
        setExpandedList(updatedData.filter((e) => e.expand));
        setRows(updatedData);
      } else {
        const resData = await loadData(false, 1);
        setPageNum(resData?.page);
        setRows(resData?.rows);
        setLoading(false);
        setIsFullDataLoad(false);
        setSelectedList([]);
        setMasterChecked(false);
        getSelectedData([]);
        localStorage.setItem("tempSelectedCapacityFilters",""); 
      }
    };
    const searchFilter = async (event, customSearch) => {
      setIsFullDataLoad(false)
      setPageNum(1)
      if (event.target.value) {
        if (event.key === "Enter" || customSearch) {
          const searchedFilters = formatSearchFilterData(customSearch);
          const updatedData = await onLoadChangeData(searchedFilters)
          setExpandedList(updatedData.filter((e) => e.expand));
          setRows(updatedData);
        }
      } else {
        setRows(rows);
        setSelectedList(SelectedList);
        getSelectedData(SelectedList);
        const selectedData = SelectedList.map((item) => item.enodbid);
         localStorage.setItem(
          "tempSelectedCapacityFilters",
          selectedData !== 0 ? JSON.stringify(SelectedList) : ""
        );
      }
    };
    const onSortSubGroups = (sectorArray = [], sortBy, sortOrder) => {
      const field = sortBy;
      return sectorArray.slice().sort((a, b) => { // shallow-copy & sort
        // const valueA = sortBy === 'secID' ? Number(a[field]) : a[field];
        // const valueB = sortBy === 'secID' ? Number(b[field]) : b[field];
        // if (typeof valueA !== 'number' || isNaN(valueA)) {
        //   return sortOrder === 'asc' ? -1 : 1;
        // }
        // if (typeof valueB !== 'number' || isNaN(valueB)) {
        //   return sortOrder === 'asc' ? 1 : -1;
        // }
        if (sortOrder === 'asc') {
          if (sortBy === 'flag' || sortBy === 'action') {
            return String(a[field]).localeCompare(String(b[field]));
          }
          return Number(a[field]) - Number(b[field]);
        } else {
          if (sortBy === 'flag' || sortBy === 'action') {
            return String(b[field]).localeCompare(String(a[field]));
          }
          return Number(b[field]) - Number(a[field]);
        }
      });
    };
    const onHandleSortFunc = async (sortBy, sortOrder) => {
      setSortingOrder(sortOrder)
      setIsClickedSort(true);
      setSortByVal(sortBy)
      setIsClickedSortCol(prevState => ({
        // ...prevState,
        [sortBy]: sortOrder === 'desc' ? true : false
      }));
      const sortedData = rows.map(item => {
        const sortedGroup = onSortSubGroups(item.groupList, sortBy, sortOrder);
        return { ...item, groupList: sortedGroup };
      });
      setRows(sortedData)
    }

    // sectors sort (internal sort)
    const applySortFunc = async (sortBy, sortOrder, tempList) => {
      let sortVal = sortBy.startsWith("enod_") ? sortBy.replace(/^enod_/, "sec_") : sortBy;
      const internalSortKeys = ['secID', 'sec_rsrp', 'sec_rsrq', 'sec_sinr', 'action', 'flag'];
      const sortedData = !internalSortKeys.includes(sortVal)
        ? tempList // pass original array from api
        : tempList.map(item => {
          sortVal = sortVal.startsWith("sec_") ? sortVal.replace(/^sec_/, "") : sortVal; // get only rsrp,rsrq... as data contains these keys
          const sortedGroup = onSortSubGroups(item.groupList, sortVal, sortOrder);
          return { ...item, groupList: sortedGroup };
        });
      setExpandedList(sortedData.filter((e) => e.expand));
      setRows(sortedData)
    }
    // sorting feature
    const onHandleSort = async (sortBy, sortOrder) => {
      let sortArr = [];
      setIsClickedSort(true);
      setSortByVal(sortBy);
      setSortingOrder(sortOrder);
      setStoredSorting([])
      setIsFullDataLoad(false) 
      setPageNum(1)
      setIsClickedSortCol(prevState => ({
        // ...prevState,
        [sortBy]: sortOrder === 'desc' ? true : false
      }));
      sortArr.push({ sortingName: sortBy, orderType: sortOrder, order: "1" });
      setStoredSorting(sortArr)
      const updatedData = await onLoadChangeData(advanceSearchFilterValues, sortArr)
      applySortFunc(sortBy, sortOrder, updatedData)
    };
    // table infinite load feature
    const loadMore = useCallback(() => {
      const loadItems = async () => {
        let tempList = rows;
        const newPageNum = pageNum + 1;
        const resData = await loadData(false, newPageNum, storedSorting, advanceSearchFilterValues);
        if (!resData || resData.rows.length === 0) {
          setPageNum(pageNum);
          setIsFullDataLoad(true);
          setLoading(false);
        } else {
          if (checkedItems) {
            tempList = [...rows];
          } else {
            tempList = [...rows, ...resData?.rows];
          }
          if (SelectedList.length !== 0) {
            const selectedEnodbId = SelectedList.map(obj => obj.enodbid);
            tempList = tempList.map(obj => {
              if (selectedEnodbId.includes(obj.enodbid)) {
                const selectedObj = SelectedList.find(selObj => selObj.enodbid === obj.enodbid);
                const updatedGroupList = obj.groupList.map(group => {
                  const selectedGroup = selectedObj.groupList.find(selGroup => selGroup.secID === group.secID);
                  if (selectedGroup) {
                    return selectedGroup;
                  } else {
                    return { ...group, selected: false };
                  }
                });
                return { ...obj, groupList: updatedGroupList};
              } else {
                return { ...obj, groupList: obj.groupList.map(group => ({ ...group, selected: false }))};
              }
            });
          }
          setPageNum(newPageNum);
          if (isClickedSort) {
            applySortFunc(sortByVal, sortingOrder, tempList)
          } else {
            setRows(tempList)
          }
          setLoading(false);
          setIsFullDataLoad(false);
        }
      };
      setLoading(true);
      loadItems();
    });
    const scrollListener = useCallback(() => {
      const tableRef = tableEl.current;
      const bottom = tableRef.scrollHeight - tableRef.clientHeight;
      const distanceBottomPercentage = 0.2; // Adjust this value as needed (e.g., 0.2 for 20% of the table's height)
      const distanceBottom = tableRef.clientHeight * distanceBottomPercentage;
      if (tableRef.scrollTop > bottom - distanceBottom && hasMore && !loading && !showSelectedRows && !isFullDataLoad) {
        loadMore();
      }
    }, [
      hasMore,
      loadMore,
      loading,
      showSelectedRows,
      isFullDataLoad,
    ]);
    useLayoutEffect(() => {
      const tableRef = tableEl.current;
      tableRef.addEventListener("scroll", scrollListener);
      return () => {
        tableRef.removeEventListener("scroll", scrollListener);
      };
    }, [scrollListener]);
    const classes = useStyles();
    const renderFields = (
      searchLabelName,
      searchKeyType,
      inputValue,
      type = 'TEXT_FIELD' // text, select
    ) => {
      return (
        <TableCell className={`${classes.stickyCell} ${classes.tableRightBorder} ${classes.cellCenter}`} style={{padding: "2.5px"}}>
          {type === 'SELECT'
            ? <>
              <FormControl className={`${classes.searchOpDropDown}`}>
                <Select
                  value={inputValue}
                  onChange={(e) => {
                    handleChange(e, searchKeyType);
                    searchFilter(e, { key: searchKeyType, value: e.target.value })
                  }}
                  displayEmpty
                  inputProps={{ 'aria-label': 'Without label' }}
                  disabled={showSelectedRows}
                  classes={{ select: classes.selectInput }}
                  style={{ height: '100%' }}
                  renderValue={() => {
                    if (inputValue) {
                      return <span style={{ fontSize: '10px', color: "white" }}>{inputValue}</span>;
                    }
                    return <span style={{ fontSize: '10px', color: '#C8C8C8', fontFamily: "Open Sans" }}>Select...</span>;
                  }}
                  {...(inputValue && {
                    IconComponent: () => {
                      return <GrFormClose className={classes.selectClose}
                        onClick={(e) => {
                          if (!showSelectedRows) {
                            handleSearchClear(e, searchKeyType)
                          }
                        }} />
                    }
                  })}
                >
                  {(searchKeyType === 'action' ? dynamicFilters.action : dynamicFilters.flag) // months are also have flag filters
                    .filter(x => x)
                    .map((item, i) => (
                      <MenuItem key={i} value={item} style={{ fontSize: '12px' }}>
                        {item}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </> : <TextField
              className={classes.smallTextField}
              id={`outlined-basic-${searchKeyType}`}
              placeholder={searchLabelName}
              value={inputValue}
              variant="outlined"
              onChange={(e) => handleChange(e, searchKeyType)}
              onKeyPress={searchFilter}
              disabled={showSelectedRows}
              InputProps={{
                endAdornment:
                  inputValue ? (
                    <IconButton
                      id={`clear-${searchKeyType}`}
                      className={classes.smallIconButton}
                      disabled={showSelectedRows}
                      onClick={(e) => { if (!showSelectedRows) handleSearchClear(e, searchKeyType) }}
                    >
                      <BiX style={{ fontSize: "small", color: "gray" }} />
                    </IconButton>
                  ) : (
                    <></>
                  ),
              }}
              size="small"
            />
    }
        </TableCell>
      );
    };
    const sortButton = (sortBy, order) => {
      return (
        sortBy === 'month' ? // sort hidden
          <IconButton className={`${classes.smallIconButton} ${`sort-btn-${sortBy}`} ${classes.hiddenSortButton}`}>
            <BiCaretDown style={{ fontSize: "small", color: "white" }} />
          </IconButton>
          : sortBy === 'secID' ? // internal sort
            order === 'asc' ?
              <IconButton className={`${classes.smallIconButton} ${`sort-btn-${sortBy}`}`} onClick={() => { onHandleSortFunc(sortBy, order); }}>
                <BiCaretDown style={{ fontSize: "small", color: "gray" }} />
              </IconButton>
              : <IconButton className={`${classes.smallIconButton} ${`sort-btn-${sortBy}`}`} onClick={() => { onHandleSortFunc(sortBy, order); }}>
                <BiCaretUp style={{ fontSize: "small", color: "gray" }} />
              </IconButton>
            : order === 'asc' ?
              <IconButton className={`${classes.smallIconButton} ${`sort-btn-${sortBy}`}`} onClick={() => { onHandleSort(sortBy, order); }}>
                <BiCaretDown style={{ fontSize: "small", color: "gray" }} />
              </IconButton>
              : <IconButton className={`${classes.smallIconButton} ${`sort-btn-${sortBy}`}`} onClick={() => { onHandleSort(sortBy, order); }}>
                <BiCaretUp style={{ fontSize: "small", color: "gray" }} />
              </IconButton>
      );
    }
    const onRowExpandable = (record) => {
      let tempList = rows;
      tempList.forEach((row) => {
        if (row._id === record._id) {
          row.expand = !row.expand ? true : false;
        }
      });
      setRows(tempList);
      setExpandedList(rows.filter((e) => e.expand));
    };
    const onRowExpandableCheck = (row) => {
      return true;
      // const isss = expandedList.filter((e) => e._id === row._id);
      // return isss.length !== 0 ? true : false;
    };

    const getFlagByMonth = (secData, month) => {
      const monthData = secData?.months?.find(itm => itm.month === month);
      return monthData ? monthData.flag : "";
    };

    const CustomDividerCell = ({ children, isCheckbox = false }) => (
      <TableCell align="center" style={{ textAlign: 'center' }} className={`${classes.tableCell} ${classes.stickyCell} ${classes.stickyBorder} ${classes.tableRightBorder}`}>
        <div style={{paddingTop: isCheckbox || showSelectedRows ? '1px' : '0px'}}>
          <span className={classes.cellBold}>{children}</span>
        </div>
      </TableCell>
    );
    
    const getSelectedCount = () => {
      let count = 0;
      SelectedList.forEach(x => x.groupList?.forEach(y => { if (y.selected) count++ }));
      return count;
    }

    return (
      <StyledTableWrapper mt={"0px"}>
        <ScrollableTableContainer ref={tableEl} className="container-test">
          {loading && <TableCircularProgress />}
          <Table className={classes.table}>
            <TableHead className={`${classes.stickyHeader}`}>
              <TableRow className={`${classes.tableRow}`}>
                <CustomDividerCell isCheckbox={true}>
                  <Checkbox
                    sx={{padding: 0}}
                    indeterminate={
                      SelectedList.length > 0 &&
                      SelectedList.length < rows.length
                    }
                    checked={MasterChecked}
                    onChange={(e) => onCheckMaster(e)}
                  />
                </CustomDividerCell>
                <CustomDividerCell>
                  EnodeBID
                  {showSelectedRows ? <></> : isClickedSortCol.enodbID ? sortButton('enodbID', 'asc') : sortButton('enodbID', 'desc')}
                </CustomDividerCell>
                <CustomDividerCell>
                  SectorID
                  {showSelectedRows ? <></> : isClickedSortCol.secID ? sortButton('secID', 'asc') : sortButton('secID', 'desc')}
                </CustomDividerCell>
                <CustomDividerCell>
                  Lat
                  {showSelectedRows ? <></> : isClickedSortCol.lat ? sortButton('lat', 'asc') : sortButton('lat', 'desc')}
                </CustomDividerCell>
                <CustomDividerCell>
                  Lon
                  {showSelectedRows ? <></> : isClickedSortCol.lon ? sortButton('lon', 'asc') : sortButton('lon', 'desc')}
                </CustomDividerCell>
                <CustomDividerCell>
                  RSRP(dbm)
                  {showSelectedRows ? <></> : isClickedSortCol.enod_rsrp ? sortButton('enod_rsrp', 'asc') : sortButton('enod_rsrp', 'desc')}
                </CustomDividerCell>
                <CustomDividerCell>
                  RSRQ
                  {showSelectedRows ? <></> : isClickedSortCol.enod_rsrq ? sortButton('enod_rsrq', 'asc') : sortButton('enod_rsrq', 'desc')}
                </CustomDividerCell>
                <CustomDividerCell>
                  SINR
                  {showSelectedRows ? <></> : isClickedSortCol.enod_sinr ? sortButton('enod_sinr', 'asc') : sortButton('enod_sinr', 'desc')}
                </CustomDividerCell>
                <CustomDividerCell>
                  Action
                  {showSelectedRows ? <></> : isClickedSortCol.action ? sortButton('action', 'asc') : sortButton('action', 'desc')}
                </CustomDividerCell>
                <CustomDividerCell>
                  Flag
                  {showSelectedRows ? <></> : isClickedSortCol.flag ? sortButton('flag', 'asc') : sortButton('flag', 'desc')}
                </CustomDividerCell>
                {dynamicFilters.months.map((month, i) => (
                  <CustomDividerCell key={i}>
                    {month}
                  </CustomDividerCell>
                ))}
              </TableRow>
              <TableRow className={`${classes.tableRow}`}>
                <TableCell className={`${classes.stickyCell} ${classes.tableRightBorder}`}/>
                {renderFields("Search...", "enodbID", enodeBID)}
                {renderFields("Search...", "secID", sectorId)}
                {renderFields("Search...", "lat", lat)}
                {renderFields("Search...", "lon", lon)}
                {renderFields("Search...", "enod_rsrp", rsrp)}
                {renderFields("Search...", "enod_rsrq", rsrq)}
                {renderFields("Search...", "enod_sinr", sinr)}
                {renderFields("Search...", "action", action, 'SELECT')}
                {renderFields("Search...", "flag", flag, 'SELECT')}
                {dynamicFilters.months.map(month => (
                  renderFields("Search...", month, monthFilters[month] ? monthFilters[month] : "", 'SELECT')
                ))}
              </TableRow>
              {/* <TableRow>
              <TableCell colSpan={8} className={classes.stickyCell} sx={{padding: "0px 0px 4px 0px"}}>
                <Divider sx={{borderBottom: '1px solid #E0E0E0'}}  orientation="horizontal" />
              </TableCell>
              </TableRow> */}
            </TableHead>
            <TableBody>
              {rows.map((item) => (
                <Fragment>
                  <TableRow style={{backgroundColor: "#f2f2f2"}}>
                    <TableCell // empty cell
                      className={`selectCheckbox ${classes.tableRightBorder}`}
                      padding="checkbox"
                    ></TableCell>
                    <TableCell className={`${classes.tableCell} ${classes.tableRightBorder} ${classes.cellBold}`} align="left">
                      <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => onRowExpandable(item)}
                        className={classes.expandIcon}
                        style={{color:"#f2f2f2"}}
                        disabled
                      >
                        {onRowExpandableCheck(item) ? (
                          <KeyboardArrowUpIcon />
                        ) : (
                          <KeyboardArrowDownIcon />
                        )}
                      </IconButton>
                      {item.enodbid}
                    </TableCell>
                      <TableCell
                        className={`${classes.tableCell} ${classes.tableRightBorder} ${classes.cellBold}`}
                        align="center"
                      >{" "} </TableCell>
                      <TableCell className={`${classes.tableCell} ${classes.tableRightBorder} ${classes.cellBold}`} align="center">
                      {item?.lat && item?.lat !== "N/A"
                        ? parseFloat(item.lat).toFixed(4)
                        : " "}
                    </TableCell>
                    <TableCell className={`${classes.tableCell} ${classes.tableRightBorder} ${classes.cellBold}`} align="center">
                      {item?.lon && item?.lon !== "N/A"
                        ? parseFloat(item.lon).toFixed(4)
                        : " "}
                    </TableCell>
                    <TableCell className={`${classes.tableCell} ${classes.tableRightBorder} ${classes.cellBold}`} align="center">
                      {item?.rsrp && item?.rsrp !== "N/A"
                        ? parseFloat(item.rsrp).toFixed(2)
                        : " "}
                    </TableCell>
                    <TableCell className={`${classes.tableCell} ${classes.tableRightBorder} ${classes.cellBold}`} align="center">
                      {item?.rsrq && item?.rsrq !== "N/A"
                        ? parseFloat(item.rsrq).toFixed(2)
                        : " "}
                    </TableCell>
                    <TableCell className={`${classes.tableCell} ${classes.tableRightBorder} ${classes.cellBold}`} align="center">
                      {item?.sinr && item?.sinr !== "N/A"
                        ? parseFloat(item.sinr).toFixed(2)
                        : " "}
                    </TableCell>
                    <TableCell className={`${classes.tableCell} ${classes.tableRightBorder} ${classes.cellBold}`} align="center">
                      {item?.action}
                    </TableCell>
                    <TableCell className={`${classes.tableCell} ${classes.tableRightBorder} ${classes.cellBold}`} align="center">
                      {item?.flag}
                    </TableCell>
                    {dynamicFilters.months.map((data, i) => (
                      <TableCell className={`${classes.tableCell} ${classes.tableRightNoBorder} ${i == (dynamicFilters.months.length - 1) ? classes.tableRightBorder : ''} ${classes.cellBold}`} align="center">
                        {" "}
                      </TableCell>
                    ))}
                  </TableRow>
                  {onRowExpandableCheck(item) ? (
                    item.groupList.map((detail) => (
                      <TableRow>
                        <TableCell className={`${classes.tableCell} ${classes.tableRightBorder}`}>
                          <Checkbox
                            onClick={(event) => onCheckRow(event, detail, item)}
                            checked={detail["selected"]}
                            className={`${classes.checkIcon}`}
                          />
                        </TableCell>
                        {expandedList.length !== 0 ? (
                          <TableCell
                            className={`${classes.tableCell}`}
                            align="center"
                          />
                        ) : (
                          // <></>
                          <TableCell
                            className={`${classes.tableCell} ${classes.tableRightBorder}`}
                            align="center"
                          />
                        )}
                        <TableCell
                          className={`${classes.tableCell} ${classes.tableRightBorder}`}
                          align="center"
                        >
                          {detail?.secID || " "}
                        </TableCell>
                        <TableCell
                          className={`${classes.tableCell} ${classes.tableRightBorder}`}
                          align="center"
                        >
                          {null}
                        </TableCell>
                        <TableCell
                          className={`${classes.tableCell} ${classes.tableRightBorder}`}
                          align="center"
                        >
                          {null}
                        </TableCell>
                        <TableCell
                          className={`${classes.tableCell} ${classes.tableRightBorder}`}
                          align="center"
                        >
                          {detail?.rsrp && detail.rsrp !== "N/A"
                            ? parseFloat(detail.rsrp).toFixed(2)
                            : " "}
                        </TableCell>
                        <TableCell
                          className={`${classes.tableCell} ${classes.tableRightBorder}`}
                          align="center"
                        >
                          {detail?.rsrq && detail.rsrq !== "N/A"
                            ? parseFloat(detail.rsrq).toFixed(2)
                            : " "}
                        </TableCell>
                        <TableCell
                          className={`${classes.tableCell} ${classes.tableRightBorder}`}
                          align="center"
                        >
                          {detail?.sinr && detail.sinr !== "N/A"
                            ? parseFloat(detail.sinr).toFixed(2)
                            : " "}
                        </TableCell>
                        <TableCell
                          className={`${classes.tableCell} ${classes.tableRightBorder}`}
                          align="center"
                        >
                          {detail?.action || " "}
                        </TableCell>
                        <TableCell
                          className={`${classes.tableCell} ${classes.tableRightBorder}`}
                          align="center"
                        >
                          {detail?.flag || " "}
                        </TableCell>
                        {dynamicFilters.months.map(x => (
                          <TableCell className={`${classes.tableCell} ${classes.tableRightBorder}`} align="center">
                            {getFlagByMonth(detail, x)}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))
                  ) : (
                    <></>
                  )}
                </Fragment>
              ))}
            </TableBody>
          </Table>
        </ScrollableTableContainer>
        <Grid container justifyContent="space-between">
          <Grid item xs={6}>
            <ScrollableFooter textAlign="left">
              {showSelectedRows ? (
                <FooterText
                  className="capacityAdvaneFooter1"
                  isClickable={true}
                  color="#006F35"
                  onClick={() => displaySelectedRows()}
                >
                  Back
                </FooterText>
              ) : checkedItems ? (
                <>
                  <FooterText
                    className="capacityAdvaneFooter2"
                    isClickable={true}
                    color="#006F35"
                    onClick={() => displaySelectedRows()}
                  >{`${getSelectedCount()} rows`}</FooterText>
                  <FooterText>{" selected"}</FooterText>
                </>
              ) :  SelectedList.length !== 0 ? 
                (<>
                  <FooterText
                    className="capacityAdvaneFooter3"
                    isClickable={true}
                    color="#006F35"
                    onClick={() => displaySelectedRows()}
                  >{`${getSelectedCount()} rows`}</FooterText>
                  <FooterText>{" selected"}</FooterText>
                </>) : <></>
              }
            </ScrollableFooter>
          </Grid>
          <Grid item xs={6}>
            <ScrollableFooter textAlign="right">{`Showing ${
              showSelectedRows ? SelectedList?.length : rows?.length
            } entries`}</ScrollableFooter>
          </Grid>
        </Grid>
      </StyledTableWrapper>
    );
  }